import { ApiResponse } from "../types/ApiResponse";
import { get } from './api';

export const getLikedStoryIds = async (userId: string): Promise<ApiResponse<string[]>> => {
  return await get<string[]>(`/auth/${userId}/likes`);
};